import { Row, Col, Input, DatePicker } from 'antd';
import { Form, Select } from 'antd';
import { idiomas } from '../../../assets/idiomas';
import { paises } from '../../../assets/paises';
import MaskedInput from 'react-input-mask'
import { validarData } from '../../../utils/date';
import { ruleDataInvalida } from '../../../utils/custom-rules-antd';
function opcoesDeFiltros(renderBotaoDeleteFiltro: Function, escolaridades: any[]) {
    const opcoesDeFiltros = [
        {
            name: 'nome',
            label: 'Nome',
            key: 0,
            item:

                <div key={0} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item name="nome" label="Nome">

                                <Input placeholder="Informe o Nome" ></Input>

                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("nome")}
                            </Form.Item>
                        </Col>

                    </Row>
                </div>
        },
        {
            name: 'dataNascimento',
            label: 'Data de Nascimento',
            key: 1,
            item:
                <div key={1} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item
                                label="Data de nascimento"
                                rules={[{ validator: ruleDataInvalida }]}
                                name="dataNascimento">
                                <MaskedInput className="ant-input" placeholder="Informe a Data" mask="99/99/9999" />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                label="&nbsp;">
                                {renderBotaoDeleteFiltro("dataNascimento")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

        },
        {
            name: 'pais',
            label: 'País',
            key: 2,
            item:

                <div key={2} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item name="pais" label="País" >

                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder="Selecione um País"
                                >
                                    <Select.Option value={""}>Selecione</Select.Option>
                                    {paises.map((p, index) => <Select.Option key={index} value={p}>{p}</Select.Option>)}

                                </Select>

                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("pais")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

        },
        {
            name: 'idioma',
            label: 'Idioma',
            key: 3,
            item:

                <div key={3} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item name="idioma" label="Idioma">

                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder="Selecione Idiomas"
                                >
                                    <Select.Option value={""}>Selecione</Select.Option>
                                    {idiomas.map((i, index) => <Select.Option key={index} value={i}>{i}</Select.Option>)}
                                </Select>


                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item name="idioma" label="&nbsp;">
                                {renderBotaoDeleteFiltro("idioma")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
        },
        {
            name: 'nomeSocial',
            label: 'Nome Social',
            key: 4,
            item:

                <div key={4} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item name="nomeSocial" label="Nome Social" >
                                <Input placeholder="Informe o Nome Social" />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("nomeSocial")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

        },
        {
            name: 'nomePai',
            label: 'Nome do Pai',
            key: 5,
            item:
                <div key={5} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item name="nomePai" label="Nome do Pai" >
                                <Input placeholder="Informe o Nome do Pai" />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("nomePai")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

        },
        {
            name: 'nomeMae',
            label: 'Nome da Mãe',
            key: 6,
            item:

                <div key={6} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item name="nomeMae" label="Nome da Mãe">
                                <Input placeholder="Informe o Nome da Mãe" />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("nomeMae")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
        },
        {
            name: 'municipioNascimento',
            label: 'Cidade Natal',
            key: 7,
            item:

                <div key={7} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item name="municipioNascimento" label="Cidade Natal" >

                                <Input placeholder="Informe a Cidade de Origem"
                                />


                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("municipioNascimento")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

        },
        {
            name: 'estadoProvincia',
            label: 'Estado/Província',
            key: 8,
            item:

                <div key={8} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item name="estadoProvincia" label="Estado/Província" >

                                <Input placeholder="Informe o Estado de Origem "
                                />

                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("estadoProvincia")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

        },
        {
            name: 'instituicao',
            label: 'Instituição de Ensino',
            key: 9,
            item:

                <div key={9} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item name="instituicao" label="Instituição de Ensino">

                                <Input placeholder="inform o Nome da Instituição" ></Input>

                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("instituicao")}
                            </Form.Item>
                        </Col>

                    </Row>
                </div>
        },
        {
            name: 'chefeFamilia',
            label: 'Chefe da Família',
            key: 10,
            item:

                <div key={10} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item label="Chefe da Família" name="chefeFamilia">

                                <Select placeholder="Selecione" >
                                    <Select.Option value="">Selecione</Select.Option>
                                    <Select.Option value="true">Sim</Select.Option>
                                    <Select.Option value="false">Não</Select.Option>
                                </Select>

                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("chefeFamilia")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
        },
        // {
        //     name: 'dataMatricula',
        //     label: 'Data da matrícula',
        //     key: 11,
        //     item:

        //         <div key={11} className="col-md-4">
        //             <Form.Item name="dataMatricula" label="Data da matrícula"
        //              rules={[{validator: ruleDataInvalida}]}
        //             >
        //                 <Row>
        //                     <Col span={20}>

        //                         <MaskedInput className="ant-input" placeholder="Informe a Data" mask="99/99/9999" />
        //                     </Col>
        //                     <Col span={4}>
        //                         {renderBotaoDeleteFiltro("dataMatricula")}
        //                     </Col>
        //                 </Row>
        //             </Form.Item>
        //         </div>

        // },
        {
            name: 'resideNoBrasil',
            label: 'Reside no Brasil',
            key: 12,
            item:

                <div key={12} className="col-md-4">
                    <Row>
                        <Col span={20}>

                            <Form.Item name="resideNoBrasil" label="Reside no Brasil?" >

                                <Select placeholder="Selecione" >
                                    <Select.Option value="">Selecione</Select.Option>;
                                    <Select.Option value="true">Sim</Select.Option>;
                                    <Select.Option value="false">Não</Select.Option>;
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item name="resideNoBrasil" label="&nbsp;" >
                                {renderBotaoDeleteFiltro("resideNoBrasil")}
                            </Form.Item>
                        </Col>
                    </Row>


                </div>

        },
        {
            name: 'sexo',
            label: 'Sexo',
            key: 13,
            item:

                <div key={13} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item name="sexo" label="Sexo">

                                <Select placeholder="selecione">
                                    <Select.Option value={""}>Selecione</Select.Option>
                                    <Select.Option value="feminino">   Feminino </Select.Option>
                                    <Select.Option value="masculino">  Masculino </Select.Option>
                                </Select>

                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("sexo")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
        },
        {
            name: 'estadoCivil',
            label: 'Estado Civil',
            key: 14,
            item:

                <div key={14} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item name="estadoCivil" label="Estado Civil">

                                <Select
                                    placeholder="Selecione um Estado Civil"
                                >
                                    <Select.Option value={""}>Selecione</Select.Option>
                                    <Select.Option value="solteiro">Solteiro(a)</Select.Option>
                                    <Select.Option value="casado">Casado(a)</Select.Option>
                                    <Select.Option value="divorciado">Divorciado(a)</Select.Option>
                                    <Select.Option value="separado">Separado(a)</Select.Option>
                                    <Select.Option value="viuvo">Viúvo(a)</Select.Option>
                                </Select>

                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("estadoCivil")}
                            </Form.Item>
                        </Col>
                    </Row>

                </div>

        }, {
            name: 'escolaridade',
            label: 'Escolaridade',
            key: 15,
            item:
                <div className="col-md-4" key={15}>
                    <Row>
                        <Col span={20}>
                            <Form.Item name="escolaridadeID" label="Escolaridade">
                                <Select
                                    placeholder="Selecione sua Escolaridade"
                                >
                                    <Select.Option value={""}>Selecione</Select.Option>
                                    {escolaridades != undefined ? escolaridades.map((option, index) => {

                                        return <Select.Option key={index} value={option.escolaridadeID}>
                                            {option.descricao}
                                        </Select.Option>;

                                    }
                                    ) : null}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("escolaridade")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
        },
        {
            name: 'estudando',
            label: 'Estudando',
            key: 16,
            item:

                <div key={16} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item label="Estudando" name="estudando">

                                <Select placeholder="selecione" >
                                    <Select.Option value="">selecione</Select.Option>
                                    <Select.Option value="true">sim</Select.Option>
                                    <Select.Option value="false">não</Select.Option>
                                </Select>

                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label="&nbsp;">
                                {renderBotaoDeleteFiltro("estudando")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
        },
        {
            name: 'ativo',
            label: 'Ativo',
            key: 17,
            item:
                <div key={17} className="col-md-4">
                    <Row>
                        <Col span={20}>
                            <Form.Item
                                label="Ativo"
                                name="ativo"
                                initialValue={"false"}>
                                <Select placeholder="Selecione" >
                                    <Select.Option value="">Selecione</Select.Option>
                                    <Select.Option value="true">Sim</Select.Option>
                                    <Select.Option value="false">Não</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                label="&nbsp;">
                                {renderBotaoDeleteFiltro("ativo")}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
        },

    ]

    return opcoesDeFiltros;
}


export default opcoesDeFiltros;